require('./bootstrap');
require('flowbite');
const { iniciarContadorCO2 } = require('./utils/counter-kilos');
const { initTabTitleNotifier } = require('./utils/tab-title-notifier');

document.addEventListener("DOMContentLoaded", function() {
    /*    const loader = document.getElementById('loading');
        if (loader) {
            // Espera 3 segundos antes de iniciar la animación de ocultar el loader
            setTimeout(() => {
                loader.classList.add('fade-out');
                // Espera el tiempo de la animación antes de ocultar el loader completamente
                setTimeout(() => {
                    loader.style.display = 'none';
                }, 1000); // Debe coincidir con la duración de la animación (1s = 1000ms)
            }, 3000);
        }*/

    iniciarContadorCO2();
    initTabTitleNotifier();

});

